export const APPLICATION_SHORTLIST = '/application/shortlist';
export const APPLICATION_VIEW = (applicationId) => `/application/${applicationId}`;
export const APPLICATION_TAG = 'application-tag';
export const FORM_DATA_UPDATE_APPLICATION = (name) => `/form-data/update/application:${name}`;
export const FORM_DATA_GET_APPLICATION = (name) => `/form-data/get/application:${name}`;
export const FORM_DATA_VERSION = '1.0';